import { addNewParkingBayApi, getAllParkingBayApi, deleteParkingBayApi } from "../../apis/parkingBay";
import { addNewParkingBaySuccess, addNewParkingBayFailure, getAllParkingBayFailure, getAllParkingBaySuccess, deleteParkingBayFailure, deleteParkingBaySuccess } from "../constants/ParkingBay";
import { showNotification } from "./notification";

function newParkingBayAddition(payload) {
  return ({type: addNewParkingBaySuccess, payload: payload})
}

function errorNewParkingbay() {
  return ({ type: addNewParkingBayFailure})
}

function getParkingBaySuccess(payload) {
  return ({type: getAllParkingBaySuccess, payload: payload})
}

function getParkingBayFail() {
  return ({ type: getAllParkingBayFailure})
}

function deleteParkingbaySuccess(id) {
  return ({type: deleteParkingBaySuccess, payload: id})
}

function deleteParkingBayFail() {
  return ({ type: deleteParkingBayFailure})
}

export function addParkingbay(payload) {
  return ((dispatch) => {
    addNewParkingBayApi(payload).then(
      (res) => {
        dispatch(newParkingBayAddition(res));
        dispatch(showNotification({
          type: 'success',
          message: 'Success',
          description: "New Parking bay Added Successfully",
        }));
      },
      (error) => {
        dispatch(errorNewParkingbay());
        dispatch(showNotification({
          type: 'error',
          message: 'Unable to Add',
          description: error?.message
        }));
      }
    )
  })
}

export function allParkingbay(query) {
  return ((dispatch) => {
    getAllParkingBayApi(query).then(
      (res) => {
        dispatch(getParkingBaySuccess(res));
      },
      (error) => {
        dispatch(getParkingBayFail());
        dispatch(showNotification({
          type: 'error',
          message: 'Failed to Get',
          description: error?.message
        }));
      }
    )
  })
}

export function deleteParkingBay(id) {
  return ((dispatch) => {
    deleteParkingBayApi(id).then(
      (res) => {
        dispatch(deleteParkingbaySuccess(id));
        dispatch(showNotification({
          type: 'success',
          message: 'Success',
          description: 'Parking Bay Deleted Successfully',
        }));
      },
      (error) => {
        dispatch(deleteParkingBayFail());
        dispatch(showNotification({
          type: 'error',
          message: 'Unable to Delete',
          description: error?.message
        }));
      }
    )
  })
}